<template>
    <div class="timeline">
        <div class="scale">
            <div class="item" v-for="time in scales">{{time.toFixed(1)}}</div>
            <div class="item last" >{{duration.toFixed(1)}}</div>
        </div>
        <div class="content">
            <div class="slider">
                <el-slider
                        class="range"
                        :value="times"
                        range
                        :max="duration"
                        @input="handleRangeChange"
                        @change="updateElements"
                >
                </el-slider>
                <el-slider
                        class="current"
                        :value="currentTime"
                        @input="handleTimeChange"
                        @change="updateElements"
                        :max="duration"
                >
                </el-slider>
            </div>
            <div class="total">
                <label>时长</label>
                <div class="control">
                    <el-input-number size="mini" :value="duration" controls-position="right" @change="handleChange" :min="1"></el-input-number>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Timeline",
        data(){
			return {
            }
        },
        computed:{
			designWidth() {
				return this.$store.state.designWidth
			},
			designHeight() {
				return this.$store.state.designHeight
			},
		    duration(){
		    	return (this.$store.state.outputDesc.duration||0)/1000
            },
			activeAction(){
		    	return this.$store.state.activeAction
            },
			currentTime(){
				return this.$store.state.currentTime||0
            },
            times(){
		    	if(this.activeAction){
		    		return [
						this.activeAction.startTime/1000,
						this.activeAction.endTime/1000
                    ]
                }else{
		    		return [0,0]
                }
            },
			scales(){
		    	const step = this.duration/8
		    	return new Array(8).fill(0).map((v,k)=>{
					return step * k
				})
            }
        },
        methods:{
			handleChange(v){
                this.$store.commit('update',{
					outputDesc: {
                        ...this.$store.state.outputDesc,
                        duration:v*1000
                    }
                })
            },
			handleTimeChange(time){
				this.$store.commit('update',{
					currentTime: time
				})
            },
			handleRangeChange(range){
				if(this.activeAction){
					this.$store.commit('update_action', {
						name: this.activeAction.name,
						startTime:range[0]*1000,
						endTime:range[1]*1000
					})
                }
				this.$store.commit('update',{
					activeAction: {
						...this.$store.state.activeAction,
						startTime:range[0]*1000,
						endTime:range[1]*1000
					},
					currentTime: (range[0]+range[1])/2
				})
            },
			updateElements(){
				this.$store.dispatch('videoTemplate/updateElements')
			}
        }
	}
</script>

<style scoped lang="scss">
    .timeline{
        background: #EFEFEF;
        border-top:1px solid #D8D8D8;
        .scale{
            height:30px;
            padding:10px 150px 0 50px;
            box-sizing: border-box;
            display: flex;
            position: relative;
            >.item{
                width:calc(100%/8);
                border-left:1px solid #CCC;
                padding-left:5px;
                font-size:12px;
                color:#666;
                &.last{
                    right:150px;
                    position: absolute;
                    text-align: right;
                    padding-left:0;
                    padding-right:5px;
                    border-left:0;
                    border-right:1px solid #CCC;
                }
            }
        }
        .content{
            height:70px;
            box-sizing: border-box;
            padding:10px 20px 10px 50px;
            display: flex;
            align-items: flex-start;
        }
        .slider{
            flex:auto;
            padding:0;
            :global(.el-slider__runway){
                margin:0;
            }
            .current{
                margin-top:15px;
            }
            .range{
                :global(.el-slider__runway){
                    height:30px;
                    background: #FFF;
                }
                :global(.el-slider__bar){
                    height:30px;
                }
                :global(.el-slider__button){
                    border-radius:0;
                    width:6px;
                    height:34px;
                }
                :global(.el-slider__button-wrapper){
                    top:-4px;
                }
            }
        }
        .total{
            width:110px;
            padding-left:20px;
            flex:none;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: space-between;
            label{
                font-size:12px;
            }
            .control{
                width:80px;
                :global(.el-input__inner){
                    text-align: left!important;
                    padding:0 5px!important;
                }
            }
            .control>*{
                width:100%;
            }
        }
    }
</style>
